var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceImGreat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5,
    cy: 94.5,
    r: 94.5,
    fill: "#6FBF46"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62 108C62.2673 125.164 77.1618 139 95.4963 139C113.831 139 128.725 125.164 128.993 108H62Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.141 79.7681C140.949 76.6116 136.671 73.3901 129.507 72.5446C122.343 71.6992 114.981 73.5471 112.964 76.679L139.141 79.7681Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6309 76.679C73.6134 73.5471 66.2515 71.6992 59.0875 72.5446C51.9234 73.39 47.6457 76.6115 49.4541 79.7681L75.6309 76.679Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.63 116.455H63.3625C62.5184 113.768 62.0457 110.933 62 108H128.993C128.947 110.933 128.474 113.768 127.63 116.455Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceImGreat);
export default __webpack_public_path__ + "static/media/Face_Im Great.85a5c7c27dbca165f63f829921d6afec.svg";
export { ForwardRef as ReactComponent };